module.exports = __webpack_public_path__ + "img/cdd6e60.png";